import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Section from "components/common/Section";
import "./styles.sass";
import { useSatismeterScore } from "hooks/useSatismeterScore";
import { useSatismeterAnswers } from "hooks/useSatismeterAnswers";
import Satismeter from "images/new-images/logo/satismeter.svg";
import StarRating from "components/common/StarRating";
import Review from "components/ReviewSection/Review";
import * as Spacer from "components/common/Spacer";


const ReviewSection = () => {
  const { answers } = useSatismeterAnswers(true, 3)
  const { ratingValue, ratingCount, maxRating, reload } = useSatismeterScore();

  return (
    <Section className="review-section">
      <div id="review-anchor" className="pathology-review-anchor pathology-anchor" />
      <Container>
        <Row>
          <Col lg={5} className="d-flex flex-column align-items-center align-items-lg-start justify-content-lg-center">
            <div className="h2 text-white mb-0 review-section-title text-lg-left">Sur {ratingCount} avis, Charles.co a obtenu la note de</div>
            <div className="review-section-score text-white">
              {`${ratingValue}`.replace(".", ",")}/{maxRating}
            </div>
            <StarRating rating={ratingValue} maxRating={maxRating} />
            <Spacer.Vertical size={32} />
            <Satismeter />
            <Spacer.Vertical size={40} />
          </Col>
          <Col lg={7} className="d-flex flex-column">
            <div className="review-section-last-review text-white font-weight-bold text-center align-self-lg-start">Derniers avis</div>
            {answers.map((answer, i) => {
              return (
                <Review answer={answer} maxRating={maxRating} />
              );
            })}
            <a
              href="https://satismeter.charles.co"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="review-section-find-out-more d-flex text-white font-weight-bolder text-center align-self-center"
            >Voir tous les avis {''}
              <div className="animated-arrow">→</div>
            </a>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default ReviewSection;
